import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import Typography from '../../../../components/Typography/Typography'
import InfoWindow from '../../../../components/Windows/InfoWindow/InfoWindow'
import ClubSummary from './components/ClubSummary/ClubSummary'
import hocCinestarClub from './hocCinestarClub'

import './CinestarClub.scss'

const CinestarClub = ({ loading, coupons, rewards, transactions, userPoints, sectionRef }) => {
    const intl = useIntl()

    return (
        <Container fluid className="cinestar-club d-flex flex-column" ref={sectionRef}>
            <Typography variant={'h2'}>{intl.formatMessage({ id: 'userProfile.cinestarClub.title' })}</Typography>
            {loading ? (
                <InfoWindow
                    color={'transparent'}
                    title={intl.formatMessage({ id: 'windows.loading.title' })}
                    description={intl.formatMessage({ id: 'windows.loading.wait' })}
                />
            ) : (
                <ClubSummary
                    coupons={coupons}
                    rewards={rewards}
                    transactions={transactions}
                    userPoints={userPoints}
                    sectionRef={sectionRef}
                />
            )}
        </Container>
    )
}

export default hocCinestarClub(CinestarClub)
